export default __webpack_public_path__ + "static/media/geladeira.794e17ea.PNG";